const prefix = 'CANVAS/';

export const FETCH_CATEGORIES = `${prefix}FETCH_CATEGORIES`;
export const FETCH_SYSTEMS = `${prefix}FETCH_SYSTEMS`;
export const FETCH_DIAGRAMS = `${prefix}FETCH_DIAGRAMS`;
export const FETCH_ICONS = `${prefix}FETCH_ICONS`;
